export const types = {
  CT: { title: 'preferenceSetting.CORPORATE', value: 'CT' },
  NH: { title: 'preferenceSetting.BANK', value: 'NH' },
  NonBank: { title: 'preferenceSetting.NON_BANK', value: 'NonBank' },
  CK: { title: 'preferenceSetting.SERCURITY', value: 'CK' },
  QU: { title: 'preferenceSetting.FUND', value: 'QU' },
  // BH: { title: 'preferenceSetting.INSURANCE', value: 'BH' },
  BHNT: { title: 'preferenceSetting.LIFE_INSURANCE', value: 'BHNT' },
  BHPNT: { title: 'preferenceSetting.NON_LIFE_INSURANCE', value: 'BHPNT' },
}

export const tableSchema = {
  CHECKBOX: 'checkbox',
  NAME: 'name',
  CREATE_AT: 'createDate',
  MODIFIED_AT: 'updateDate',
  ACTION: 'action',
}

export const deleteTypes = {
  IN: 'IN',
  NOTIN: 'NOTIN',
}
